/**
 * contiene la información para el manejo de Bases.
 */
export const defaultNiveles = () => {
  return {
    nivel: '',
    descripcion: '',
  };
};

/**
 * contiene la información para el manejo de Äreas.
 */
export const defaultUbicacion = () => {
  return {
    id: '',
    id_nivel: '',
    descripcion: '',
    nivel: '',
    ubicacion_hija: '',
  };
};

/**
 * contiene la información para el manejo de Äreas.
 */
export const defaultUbicacionEmpresa = () => {
  return {
    id_ubicacion: '',
    id_parent: ''
  };
};

/**
 * contiene la información para el manejo de Äreas.
 */
export const filtro = () => {
  return{
    ubicacion: '',
    id_nivel: '',
    page: 1,
    perPage: 10,
  };
};

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
  selectedNivel: defaultNiveles(),
  selectedUbicacion: defaultUbicacion(),
  selectedUbicacionEmpresa: defaultUbicacionEmpresa(),
  errorNivel: true,
  errorUbic: true,
  id_ubicacion: '',
  ultimo_id: '',
  ubicacionPadre: {},
  niveles: [],
  nivelesActivos: [],
  ubicaciones: [],
  ubicacionEmpresa: [],
  arbolUbicaciones: [],
  confirmarEliminado: false,
  ubicacionProductos: '',
  ubicacionAsig: {
    id_nivel: ''
  },
  ubicacionParent: {
    ubicacion: ''
  },
  modal: {
    ver: false,
    paso: 0,
    loader: false
  },
   filtro: filtro(),
  accion_niveles: 'Crear',
  filtro_niveles: {
    descripcion: ''
  },
  modal_niveles: {
    ver: false
  },
  modal_ubicaciones: {
    ver: false
  },
  asociar: false
};
